import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appDateMask]',
    standalone: true,
})
export class DateMaskDirective {
    constructor(private readonly element: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const inputValue = input.value.replace(/\D/g, '');
        const formattedValue = this.formatDate(inputValue);
        this.element.nativeElement.value = formattedValue;
    }

    private formatDate(inputValue: string): string {
        const day = inputValue.slice(2, 4) || '';
        const month = inputValue.slice(0, 2) || '';
        const year = inputValue.slice(4, 8) || '';

        return `${month.length === 2 ? month + '/' : month}${day.length === 2 ? day + '/' : day}${year}`;
    }
}
